import {useContext, useState} from 'react'

import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'

import {CardAdSkeleton} from './cardAdSkeleton.js'

export const CardAd = ({adId}) => {
  const [adInfo, setAdInfo] = useState({
    data: {
      attributes: [],
      image: '',
      isFavorite: null,
      title: '',
      price: null
    },
    error: null,
    loading: true
  })
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const urlStatics = config.get('urlStatics')
  const emptyVehicleImage = config.get('technicalDetails').TECHNICAL_DETAILS_EMPTY_VEHICLE_IMAGE
  const defaultImage = `${urlStatics}${emptyVehicleImage}`

  const getAdDetails = async adId => {
    const [adDetailsError, adDetailsResponse] = await domain.get('get_ad_details_ads_use_case').execute({adId})
    if (adDetailsError) setAdInfo({data: {}, error: true, loading: false})
    else {
      const {ad} = adDetailsResponse
      const attributes = [
        {key: 'place', value: ad.province},
        {key: 'fuel', value: ad.fuelType},
        {key: 'year', value: ad.year},
        {key: 'kilometers', value: `${ad.km ? i18n.n(ad.km) : 'N/D'} km`}
      ]
      setAdInfo({
        data: {
          attributes: attributes || [],
          image: ad.photos[0] || defaultImage,
          isFavorite: ad.isFavorite,
          title: ad.title || '',
          price: ad.price || null
        },
        error: false,
        loading: false
      })
    }
  }

  const showAdInfo = adInfo.error !== null && adInfo.error !== true && !adInfo.loading

  useMount(() => {
    getAdDetails(adId)
  })

  return (
    <div className="mt-ReservationModal-cardAdContainer">
      {showAdInfo ? (
        <>
          <div className="mt-ReservationModal-cardAdImage">
            <AtomImage src={adInfo.data.image} alt={adInfo.data.title} />
          </div>
          <div className="mt-ReservationModal-cardAdInfo">
            <span className="mt-ReservationModal-cardAdTitle">{adInfo.data.title}</span>
            <span className="mt-ReservationModal-cardAdPrice">{i18n.c(adInfo.data.price)}</span>
          </div>
          <ul className="mt-ReservationModal-cardAdAttributes">
            {adInfo.data.attributes.filter(Boolean).map(
              (attribute, index) =>
                Boolean(attribute.value) && (
                  <li className="mt-ReservationModal-cardAdAttributesItem" key={`${attribute.value}-${index}`}>
                    {attribute.value}
                  </li>
                )
            )}
          </ul>
        </>
      ) : (
        <CardAdSkeleton />
      )}
    </div>
  )
}

CardAd.displayName = 'CardAd'
CardAd.propTypes = {
  adId: PropTypes.string
}
